export default "__VITE_ASSET__DccUn_qc__"